import BasicSparkLine from "./sparkline";
import BasicLineChart from "./lineDemo";
import { useEffect, useState } from "react";
export default function Dashboard({ flight, lastupdate, backcolor, border }) {
  const [speed, setspeed] = useState(0);
  const [total, settotal] = useState(0);
  const [avgSpeed, setavgSpeed] = useState(0);
  const [avgTitude, setavgTitude] = useState(0);
  const [titude, settitude] = useState(0);

  useEffect(() => {
    if (flight && flight.length) {
      let allspeed = 0;
      let allTitude = 0;
      const totalflight = flight.length;
      settotal(flight.length);
      // setspeed(0);
      // settitude(0);
      const flightMap = flight.map((e) => {
        allspeed += e[9] || 0;
        allTitude += e[7] || 0;
      });
      setspeed(allspeed);
      settitude(allTitude);
      setavgSpeed((allspeed / totalflight).toFixed(2));
      setavgTitude((allTitude / totalflight).toFixed(2));
    }
  }, [flight, lastupdate]);

  return (
    <div
      style={{
        width: "20%",
        display: "flex",
        background: `${backcolor}`,
        flexDirection: "column",
        paddingTop: "5px",
        paddingLeft: "10px",
        paddingRight: "10px",
        border: `20px solid ${border}`,
        color: `white`,
        boxShadow: `inset 0 0 15px ${border},0 0 15px ${border}`,
        minHeight: "60vh",
        height: "auto",
      }}
    >
      <p>GLOBAL AIT TRAFFIC</p>
      <hr style={{ width: "80%" }}></hr>
      <div
        style={{
          display: "flex",
          width: "100%",
          padding: "5px",
          margin: "0",
          height: "10%",
          justifyContent:"space-around"
        }}
      >
        <div>
          <p style={{ color: `white`, margin: "0" }}>
            TOTAL<br></br>AINIPLANES
          </p>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <p style={{ margin: "0", marginTop: "0", color: `$white` }}>
            {total}
          </p>
          <BasicLineChart></BasicLineChart>
        </div>
      </div>
      <br></br>
      <hr style={{ width: "80%", margin: " 0 30px" }}></hr>
      <div
        style={{
          height: "10%",
          display: "flex",
          width: "100%",
          justifyContent: "space-around",
          padding: "5px",
          margin: "0",
        }}
      >
        <div>
          <br></br>
          <p style={{ color: `white`, margin: "0" }}>
            AVG SPEED<br></br>
          AVGALTITUDE {avgTitude} FT
          </p>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <p style={{ margin: "0", marginTop: "20px", color: `white` }}>
            {avgSpeed} TS
          </p>
          <BasicLineChart></BasicLineChart>
        </div>
      </div>
      <br></br>
      <br></br>
      <hr style={{ width: "80%", margin: " 0 30px" }}></hr>

      <h4 style={{ margin: "10px" }}>MOST CONGESTED AREAS</h4>
      <div
        style={{
          display: "flex",
          height: "10%",
          margin: "2px",
          justifyContent: "space-around",
          width: "100%",
        }}
      >
        <div>
          <p style={{ margin: "2px", color: `white` }}>
            1.N.Atlantic
          </p>
          <p style={{ margin: "2px", color: `white` }}>
            2.SE.Asia
          </p>
          <p style={{ margin: "2px", color: `white` }}>
            3.Eroupe 
          </p>
        </div>
        <BasicSparkLine></BasicSparkLine>
      </div>
      <br></br>
      <br></br>
      <h4 style={{ margin: "10px", color: `white` }}>TOP AIRLINES (FLIGHTS)</h4>
      <div
        style={{ display: "flex", margin: "2px", height: "10%", gap: "0px" }}
      >
        <div
          style={{
            margin: "2px",
            display: "flex",
            justifyContent: "space-around",
            width: "100%",
          }}
        >
          <div>
            <p style={{ margin: "2px", color: `white` }}>1.Delta (880)</p>
            <p style={{ margin: "2px", color: `white` }}>2.Luthamsa (820)</p>
            <p style={{ margin: "2px", color: `white` }}>3.Emirats</p>
          </div>
          <BasicSparkLine></BasicSparkLine>
        </div>
      </div>
    </div>
  );
}
